<template>
	<Tab :class="{ open }" v-bind="$props" @toggle="toggle">
		<template v-slot:header>
			<TabHeader
				icon="glass"
				label="Glass bottles"
				:value="value"
				:open="open"
			/>
		</template>
		<template v-slot:content>
			<Corridor>
				<p class="tab__prompt">
					How many drinks in glass bottles does your household consume each
					week? This does not include larger bottles used for wine or spirits.
				</p>
				<div class="tab__sliders">
					<Slider
						v-for="slider in sliders"
						:key="slider.label"
						v-bind="slider.data"
						v-model="slider.slider"
						@dragend="trackSlider(slider.data)"
					/>
				</div>
			</Corridor>
		</template>
	</Tab>
</template>

<script>
import tab from '@/mixins/tab'
import sliders from '@/mixins/sliders'
import sliderAnalytics from '@/mixins/sliderAnalytics'

const SLIDERS = [
	{ title: 'Soft drink' },
	{ title: 'Kombucha' },
	{ title: 'Alcohol' }
]

export default {
	name: 'TabGlass',
	mixins: [tab, sliders(SLIDERS), sliderAnalytics('Glass Bottles')]
}
</script>

<style lang="scss" scoped>
@import '~scss/mixins';
@include tab($green-65);
</style>
